/* Global App State that can be changed by components */

const state = {
   viewTitle: null,
   navDrawer: false
};


const mutations = {
   setViewTitle(state, title) {
      state.viewTitle = title;
   }

};

const actions = {
   setViewTitle: ({commit}, title) => {
      commit('setViewTitle', title);
   }
};

export default {
   namespaced: true,
   state,
   mutations,
   actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/app.js